$(document).ready(function () {


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * teleport links
    // *
    // * @set outer parent element class: js-href-teleport-wrapper
    // * @set link (<a> tag) element class: js-href-teleport-link
    // * @set element to add the link to class: js-href-teleport
    // *
    // * This adds a link tag (<a>) to other elements within a wrapper
    // * links comes from a link. Example: add a link to h2, image etc. inside a teaser
    // *
    $(".js-href-teleport").each(function () {
        var $link = $(this).parents(".js-href-teleport-wrapper").find(".js-href-teleport-link"),
            href = $link.attr("href"),
            target = $link.attr("target") ? $link.attr("target") : '_self';

        if (href) {
            $(this).wrapInner('<a href="' + href + '" target="' + target + '"></a>');
        }
    });



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * parent clickable elements (excludes links inside)
    // *
    // * @set outer parent element class: js-click-item-parent
    // * @set link (<a> tag) element class: js-click-item-link
    // *
    // * This makes the whole element clickable and still
    // * makes other links inside clickable with their target
    // *
    $(".js-click-item-parent").delegate('a', 'click', function (e) {
        var target = $(this).attr("target"),
            url = $(this).attr("href");

        if (target == "_blank") {
            window.open(url);
        } else {
            window.location = url;
        }
        return false;
    }).click(function () {
        var target = $(this).find("a.js-click-item-link").attr("target"),
            url = $(this).find("a.js-click-item-link").attr("href");

        if (target == "_blank") {
            window.open(url);
        } else {
            window.location = url;
        }
        return false;
    });




    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * animateIn
    // *
    // *
    var offset = 80; // Distance from Browserbottom & -top where the animation should start

    function fadeInElements() {
        var viewPortStart = $(window).scrollTop(),
            viewPortEnd = viewPortStart + $(window).height();


        $(".animateIn:visible").each(function () {
            var elementTop = $(this).offset().top,
                elementBottom = $(this).offset().top + $(this).outerHeight();

            if ((elementTop + offset) <= viewPortEnd && (elementBottom - offset) >= viewPortStart) {
                var delay = $(this).data("animation-delay");
                $(this).css("transition-delay", delay + "s").addClass("animateIn--active");
            } else {
                $(this).removeClass("animateIn--active");
            }
        });
    }

    $(window).scroll(function () {
        fadeInElements();
    });

    fadeInElements();


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * add target blank to external links
    // *
    // *
    $('a:not([data-targetblank=ignore])').each(function () {
        if (location.hostname === this.hostname || !this.hostname.length) {
            // ... do nothing?
        } else {
            $(this).attr('target', '_blank');
        }
    });

    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * navButton
    // *
    // *
    $(".js-navbutton").click(function () {
        $(".js-header").toggleClass("navOpen");
        $("body").toggleClass("freeze");
        $(this).toggleClass("active");
        $(".js-navmobile").toggleClass("active");
    });

    $(document).on('keydown', function (e) {
        if (e.key === 'Escape' || e.keyCode === 27) {
            $(".js-header").removeClass("navOpen");
            $("body").removeClass("freeze");
            $(".js-navbutton").removeClass("active");
            $(".js-navmobile").removeClass("active");
            $(".js-clickimage-target").removeClass("active");
        }
    });

    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * navlist
    // *
    // *
    const $navList = $('.js-nav-list');
    const $sections = $('[data-nav-marker]');

    function updateActiveNav() {
        let currentSectionId = null;

        // Find the section in view
        $sections.each(function () {
            const $section = $(this);
            const sectionTop = $section.offset().top;
            const sectionHeight = $section.outerHeight();
            const scrollPos = $(window).scrollTop();
            if (scrollPos >= sectionTop - 161 && scrollPos < sectionTop + sectionHeight - 160) {
                currentSectionId = $(this).attr("data-nav-marker");
                return false; // Break the loop
            }
        });

        // Remove active class from all nav items
        $navList.find('li').removeClass('active');

        // Add active class to the corresponding nav item
        if (currentSectionId) {
            $navList.find(`li a[href*="${currentSectionId}"]`).parent('li').addClass('active');
        }
    }

    // Run on scroll
    $(window).on('scroll', updateActiveNav);

    // Run once on page load
    updateActiveNav();

    $navList.find("li a").click(function () {
        $(".js-navbutton").removeClass("active");
        $(".js-navmobile").removeClass("active");
        $(".js-header").removeClass("navOpen");
        $("body").removeClass("freeze");
    })



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * tabs
    // *
    // *
    $(".js-tab").click(function () {
        $(this).addClass("active").siblings().removeClass("active");
        var index = $(this).index();
        var $parent = $(this).closest(".js-tab-parent");
        var $targets = $parent.find(".js-tab-target");
        $targets.removeClass("active");
        $targets.eq(index).addClass("active");

        var $currentSlider = $targets.eq(index).find('.js-card-slider-track');
        $currentSlider.slick('setPosition');
        // $currentSlider.slick('slickPlay'); // Start autoplay
    });



    // Handle scrolling
    $('.js-tab').on('click', function () {
        const $tab = $(this);
        const $wrapper = $('.js-tab-wrapper');


        // Calculate the scroll position to center the tab
        const tabLeft = $tab.position().left + $wrapper.scrollLeft();
        const tabWidth = $tab.outerWidth();
        const wrapperWidth = $wrapper.outerWidth();

        const scrollTo = tabLeft - (wrapperWidth / 2) + (tabWidth / 2);

        // Scroll to the calculated position
        $wrapper.animate({
            scrollLeft: scrollTo
        }, 300);
    });


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * clickImage
    // *
    // *
    $(".js-clickimage-button").click(function () {
        $(this).closest(".js-clickimage-parent").find(".js-clickimage-target").removeClass("active");
        $(this).siblings(".js-clickimage-target").addClass("active");
    });

    $(".js-clickimage-close").click(function () {
        $(this).closest(".js-clickimage-target").removeClass("active");
    })





    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * cardSlider
    // *
    // *
    $(".js-card-slider").each(function () {
        var loop = $(this).data("loop");
        $slider = $(this).find(".js-card-slider-track");

        $slider.slick({
            fade: false,
            infinite: loop,
            arrows: true,
            autoplay: false,
            autoplaySpeed: 2500,
            adaptiveHeight: true,
            speed: 1000,
            waitForAnimate: true,
            dots: true,
            slidesToShow: 3,
            pauseOnHover: false,
            appendDots: $(this).find(".js-card-slider-dots"),
            prevArrow: $(this).find(".js-card-slider-prev"),
            nextArrow: $(this).find(".js-card-slider-next"),
            responsive: [
                {
                    breakpoint: 1400,
                    settings: {
                        slidesToShow: 2,
                    },
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                    },
                },
            ],
        });

    });


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * accordion
    // *
    // *
    $(".js-accordion-button").click(function () {
        // Toggle the aria-expanded attribute for the current accordion item
        const $content = $(this).siblings(".js-accordion-content");
        const isExpanded = $content.attr("aria-expanded") === "true";
        $content.attr("aria-expanded", !isExpanded);

        // Close other accordion items
        $(this).parents(".js-accordion-wrapper")
            .find(".js-accordion-content")
            .not($content)
            .attr("aria-expanded", "false");

        setTimeout(() => {
            $(this)[0].scrollIntoView({ behavior: 'smooth' });
        }, 400);
    });

    function openAccordionFromHash() {
        let hash = window.location.hash.split('#')[1];
        if (hash && $("#" + hash).hasClass("js-accordion-button") && $("#" + hash).siblings(".js-accordion-content").attr("aria-expanded") !== "true") {
            $("#" + hash).click();
        }
    }

    // open acoordion on load
    openAccordionFromHash();

    // open accordion from same page
    $(window).on('hashchange', function () {
        openAccordionFromHash();
    });

});
